import { useEffect, useState } from "react";
import "./App.css";
import TestButton from "./../../react-components/TestButton"; //"./components/TestButton";
import { BsFillGeoAltFill } from "react-icons/bs";
import { AiFillPrinter } from "react-icons/ai";
import { SearchComponent } from "./../search/SearchComponent";
import ModalWrap from "./../../react-components/modal/ModalWrap";
import DeleteModal from "./../../react-components/modal/delete/DeleteModal";
/*import ErrorRepeat from "./../../react-components/modal/error/ErrorRepeat";
import PleaseWait from "./../../react-components/modal/wait/PleaseWait";*/

import SearchDivOverlay from "./../../react-components/SearchDivOverlay";

import Map from "./../../../Map";
import SideBar from "../sidebar/SideBarTest";
//import UpdateSidebar from "../modal/update/UpdateSidebar";
//import BottomMenu from "../menu/BottomMenu";
//import PrintModal from "../modal/PrintModal";
import Statistic from "../modal/statistic/Statistic";

function TestPage() {
  // console.log("testPage");
  const [open, setOpen] = useState(false);
  const [statistic, setStatistic] = useState(false);
  // const [err, setErr] = useState(false);
  const [wait, setWait] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [infoSide, setInfoSide] = useState(``);
  const [isSidebar, setSidebar] = useState(false);
  const [isUpdateSidebar, setUpdateSidebar] = useState(false);
  const [info, setInfo] = useState([]);
  const [isBottom, setIsBottom] = useState(false);
  const handleClick = (event) => {
    setIsActive((current) => !current);
  };
  const handeleDelete = (event) => {
    console.log("deleted");
  };
  function handeleClickFind() {
    console.log("find");
  }
  async function fetchData(params) {
    const link = infoSide;
    // console.log(typeof link + " ---" + link);
    const res = await fetch(`${link}`);
    const results = await res.json();
    console.log(results);
    setInfo(results);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function fetchSidebar(params, shuna__number) {
    const link = params;
    // console.log(typeof link + " ---" + link);
    const shuna__header = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/object_params/getMeasurement/277`
    );
    let result = await shuna__header.json();
    let some = { abc: "", ia: "Ia", ub: "Ub" };
    result.unshift(some);
    fetch(`${link}`)
      .then((response) => response.json())
      .then((data) => {

       // table.appendChild(headerRow);
        const side = document.querySelector(".info-side");
        const HeaderShuno = document.createElement("div");
        HeaderShuno.classList.add("shuno__header");
        HeaderShuno.textContent = `ШУНО - ${shuna__number}`;
        const del = document.querySelector(".info-side");
        if (del.classList.contains("passport__info")) {
          side.appendChild(HeaderShuno);
        


        const categoryBlock = document.createElement("div");
        categoryBlock.classList.add("category-block");

        const categoryTable = document.createElement("table");

        
          const row = document.createElement("tr");
          const idCell = document.createElement("th");
          idCell.textContent = "№";
          idCell.classList.add("idCell");
          const paramnameCell = document.createElement("th");
          paramnameCell.textContent = "Позиция";
          paramnameCell.classList.add("paramnameCell");
          const paramvalueCell = document.createElement("th");
          paramvalueCell.textContent = "Данные";
          paramvalueCell.classList.add("paramvalueCell");

          row.appendChild(idCell);
          
            row.appendChild(paramnameCell);
            row.appendChild(paramvalueCell);
          
          categoryTable.appendChild(row);
        

        categoryBlock.appendChild(categoryTable);
        //categoryBlock.appendChild(categoryHeader);
        side.appendChild(categoryBlock);
        }
        //side.appendChild(headerRow);
        // ... (предыдущий код
        // Создаем объект для хранения данных по категориям
        const categoriesData = {};
        data.forEach((obj) => {
          if (!categoriesData[obj.category_id]) {
            categoriesData[obj.category_id] = [];
          }

          categoriesData[obj.category_id].push(obj);
        });

        for (const categoryId in categoriesData) {
          const categoryBlock = document.createElement("div");
          categoryBlock.classList.add("category-block");
          const categoryData = categoriesData[categoryId];
          const categoryHeader = document.createElement("div");
          categoryHeader.classList.add("category-header");
          categoryHeader.textContent = categoryData[0].catname;

          const categoryTable = document.createElement("table");

          let counter = 1;
          categoryData.forEach((obj) => {
            const row = document.createElement("tr");
            const idCell = document.createElement("td");
            idCell.textContent = counter++;
            idCell.classList.add("idCell");
            const paramnameCell = document.createElement("td");
            paramnameCell.textContent = obj.paramname;
            paramnameCell.classList.add("paramnameCell");
            const paramvalueCell = document.createElement("td");
            paramvalueCell.textContent = obj.paramvalue;
            paramvalueCell.classList.add("paramvalueCell");

            row.appendChild(idCell);
            const del = document.querySelector(".info-side");
            if (del.classList.contains("opora__info")) {
              row.appendChild(paramvalueCell);
              row.appendChild(paramnameCell);
            } else {
              row.appendChild(paramnameCell);
              row.appendChild(paramvalueCell);
            }
            categoryTable.appendChild(row);
          });

          categoryBlock.appendChild(categoryTable);
          categoryBlock.appendChild(categoryHeader);
          side.appendChild(categoryBlock);
        }
        if (del.classList.contains("passport__info")) {
          const categoryBlock = document.createElement("div");
          categoryBlock.classList.add("category-block");
          categoryBlock.classList.add("last__block");
          const categoryHeader = document.createElement("div");
          categoryHeader.classList.add("category-header");
          categoryHeader.textContent = "Замеры тока и напряжения А, В, С";
          const categoryTable = document.createElement("table");
          let counter = 1;

          result.forEach((obj) => {
            const row = document.createElement("tr");
            const idCell = document.createElement("td");
            idCell.textContent = counter++;
            idCell.classList.add("idCell");
            const paramnameCell = document.createElement("td");
            paramnameCell.textContent = obj.abc;
            paramnameCell.classList.add("paramnameCell"); //last__paramnameCell
            paramnameCell.classList.add("last__paramnameCell");
            const paramvalueCell = document.createElement("td");
            paramvalueCell.textContent = obj.ia;
            paramvalueCell.classList.add("paramvalueCell");
            paramvalueCell.classList.add("last__paramvalueCell");
            const newparam = document.createElement("td");
            newparam.textContent = obj.ub;
            newparam.classList.add("last__newparam");

            row.appendChild(idCell);
            row.appendChild(paramnameCell);
            row.appendChild(paramvalueCell);
            row.appendChild(newparam);
            categoryTable.appendChild(row);
          });
          categoryBlock.appendChild(categoryTable);
          categoryBlock.appendChild(categoryHeader);
          console.log(categoryBlock);
          side.appendChild(categoryBlock);
        }
      });
  }
  const ShowSideBar = (event) => {
    // if (!isSidebar) {
    //   setSidebar(true);
    // }
    console.log("??");
    const del = document.querySelector(".info-side");
    del.innerHTML = "";
    console.log("!!");
    let idShow = event.target.id;
    console.log(idShow);
    if (idShow === "1") {
      del.classList.remove("opora__info");
      del.classList.add("passport__info");
      let shuna__number = "988";
      setInfoSide(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${649}`
      );
      fetchSidebar(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${649}`,
        shuna__number
      );
    } else if (idShow === "2") {
      del.classList.remove("passport__info");
      del.classList.add("opora__info");
      setInfoSide(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${41}`
      );
      fetchSidebar(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${41}`
      );
    }
  };
  const [menu, setMenu] = useState([]);
  async function fetchMenu(params) {
    const link = `http://localhost:8000/api/object_params/getParamPolesByLinkedtp/%D0%A8%D0%A3%D0%9D%D0%9E%2006-002`;
    await fetch(`${link}`)
      .then((response) => response.json())
      .then((data) => {
        console.log("!!!!!!!!");
        console.log(data);
        setMenu(data);
      });
  }
  // useEffect(() => {
  //   fetchSidebar();
  // }, [fetchSidebar, infoSide]);
  const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPPandTP?name=`;
  const [print, setPrint] = useState(false);
  const [leftClick, setLeftClick] = useState(true);
  const [rightClick, setRightClick] = useState(false);
  const printClik = () => {
    console.log("print");
    setLeftClick(true);
    setRightClick(false);
    // setPrint();
    console.log(print);
    
  };
  // async function fetchStatic(params) {
  //   console.log("static");
  //   const link = `http://localhost:8000/api/object_params/getAllStat`;
  //   const res = await fetch(`${link}`);
  //   console.log(res);
  //   const results = await res.json();
  //   console.log(results);
  //   setStatistic(results);
  // }
  // useEffect(() => {
  //   fetchStatic();
  // }, []);
  return (
    <div className="test__page">
      {statistic && (
        <ModalWrap>
          <Statistic setStatistic={setStatistic}></Statistic>
        </ModalWrap>
      )}
      {open && (
        <ModalWrap>
          <DeleteModal handeleDelete={handeleDelete} set={setOpen} />
        </ModalWrap>
      )}
      {/*isUpdateSidebar && (
        <ModalWrap>
          <UpdateSidebar
            info={info}
            fetchData={fetchData}
            set={setUpdateSidebar}
          ></UpdateSidebar>
        </ModalWrap>
      )*/}
      <div className="sidebar__style">
        <SideBar
          isActive={isSidebar}
          setIsActive={setSidebar}
          info={infoSide}
          setUpdateSidebar={setUpdateSidebar}
        ></SideBar>
      </div>
      {/*print && <PrintModal print={print}></PrintModal>*/}
     {/* <div className="buttom__style">
        <BottomMenu
          isBottom={isBottom}
          setIsBottom={setIsBottom}
          menu={menu}
          // setUpdateSidebar={setUpdateSidebar}
        ></BottomMenu>
      </div>*/}
      <button id="showUserLocation" class="location-button">
      <BsFillGeoAltFill className="btn__icon"></BsFillGeoAltFill>
    </button>
      <div className="div__style">
      
        <div className="geo__style">
          <TestButton handele={printClik} setWait={setWait} set={setPrint}>
            <BsFillGeoAltFill className="btn__icon"></BsFillGeoAltFill>My Geo
          </TestButton>
        </div>
        <SearchComponent
          handeleClickFind={handeleClickFind}
          home={true}
          link={searchLink}
          // propsValue={""}
        ></SearchComponent>
        <div className="print__style">
          <TestButton handele={printClik} setWait={setWait} set={setPrint}>
            <AiFillPrinter className="btn__icon"></AiFillPrinter>Print
          </TestButton>
        </div>
        <div className="print__style">
          <TestButton setWait={setWait} set={setStatistic}>
            Show Statistic
          </TestButton>
        </div>
      </div>
      <div className="div__style_mini">
        <SearchComponent
          handeleClickFind={handeleClickFind}
          link={searchLink}
          home={false}
          propsValue={"propsValue"}
        ></SearchComponent>
      </div>
      {/* <SearchDivOverlay handeleClickFind={handeleClickFind} /> */}
      {/* <div className="delete__style">
        <TestButton setWait={setWait} set={setOpen}>
          Удалить
        </TestButton>
      </div> */}
      <div className="show__btns">
        <div className="show__btn" id={1} onClick={ShowSideBar}>
          Show Passport{" "}
        </div>
      </div>
      <div className="show__btns second__btn">
        <div className="show__btn" id={2} onClick={ShowSideBar}>
          Show Opora{" "}
        </div>
      </div>
      <Map />
    </div>
  );
}

export { TestPage };
